import { TipoIdentificacion } from '../../domain/model/maestro/entity/tipo-identificacion.model';
import { PacienteCoberturaNh } from '../../domain/model/no-hospitalario/solicitud/dto/paciente-cobertura-nh-dto';
import { PacienteCobertura } from '../../domain/model/remision/dto/paciente-cobertura-dto';

export class PacientesMockData {

  /**
   * Array de pacientes simulados para testing
   */
  public static readonly PACIENTES_SIMULADOS: PacienteCobertura[] = [
    
    // ✅ PACIENTE CON DOCUMENTO 1
    new PacienteCobertura(
      null,                    // idRemisionPK
      'María Elena',                     // nombre
      'González López',                  // apellido
      new TipoIdentificacion(            // tipoIdentificacion
        '1',
        'CC',
        'Cédula de Ciudadanía',
        '13',
        'C'
      ),
      '1',                               // numeroIdentificacion
      402469200000 as any,                      // fechaNacimiento
      '40',                              // edad
      'Masculino',                               // sexo
      'Casada',                          // estadoCivil
      {                                  // tipoPlanParticular
        id: '2',
        idTipoPlanParticular: '2',
        descripcion: 'Plan Premium',
        nit: '800123457'
      },
      null,             // ocupacion
      null,        // email
      null,                         // tipoAsegurador
      null,                         // estadoSuspension
      true,                             // coberturaDomiciliaria
      null,                     // fechaLimiteCobertura
      {                                 // tipoAfiliacion
        id: '3',
        nombre: 'PÓLIZA',
        nombreAseguradora: 'SURA SEGUROS',
        idPlan: '3'
      },
      [                                 // convenios
        {
          planContrato: '074',
          codigoRamo: '091',
          tipoRamo: 'C',
          tipoPlanSalud: 'POLIZA',
          descripcionPlanContrato: 'Póliza Clásica',
          numeroPlan: '2|CLÁSICO',
          codigoProducto: '15',
          anexoUrgencias: false,
          anexoConsultaExterna: false,
          anexoAtencionDomiciliaria: true,
          fechaInicioVigenciaAsegurado: 1743397200000 as any, // ✅ Cast a any
          fechaFinVigenciaAsegurado: 1774933200000 as any,
          numeroContrato: 'CNT-002'
        }
      ],
      null,                           // nivelIngreso
      'IPS SURA SEDE NORTE',            // ipsBasicaAsignada
      null,                      // lugarAtencion
      'AÑOS',                           // unidadEdad
      null,                               // bebeCanguro
      '',                               // codigoARL
      null,                             // medidaDepeso
      null,                             // peso
      null,                               // codigoSiniestro
      'PLAN_COMPLEMENTARIO_A',          // planComplementario
      true,                             // esEditable
      null,                          // priorizacion
      null,                     // fechaConsultaMedica
      null,                     // fechaInicioSintomas
      null,                     // fechaTomaMuestra
      null,                     // tipoCasoCovid
      null,                // integracion
      null, // observacion
      null,                             // pacienteSinFechaNacimiento
      null,                        // encounterId
      null,                             // embarazada
      null,                             // oxigenoDependiente
      null,            // medicoCreadorTipo
      null,                       // medicoCreadorNumero
      null,                              // codigoSexo
      null,                       // descSexo
      null,                              // codigoPlan
      null,                         // descPlan
      null,                         // descMunicipio
      null,                          // codigoDaneMunicipio
      null,                   // descDepartamento
      null,                             // codigoDaneDpto
      'PISO_2',                         // pisoCovid
      null,                                // subNivel
      null,                     // vacunacion
      'María Elena González López',     // nombrePersonaAutoriza
      true,                             // tienePoliza
      false,                            // tienePac
      false,                            // tienePOS
      true                             // tieneArl
    ),

    
    // ✅ PACIENTE CON DOCUMENTO 2
    new PacienteCobertura(
      null,                    // idRemisionPK
      'María Elena',                     // nombre
      'González López',                  // apellido
      new TipoIdentificacion(            // tipoIdentificacion
        '1',
        'CC',
        'Cédula de Ciudadanía',
        '13',
        'C'
      ),
      '2',                               // numeroIdentificacion
      402469200000 as any,               // fechaNacimiento
      '40',                              // edad
      'Masculino',                       // sexo
      'Casada',                          // estadoCivil
      {                                  // tipoPlanParticular
        id: '2',
        idTipoPlanParticular: '2',
        descripcion: 'Plan Premium',
        nit: '800123457'
      },
      null,             // ocupacion
      null,        // email
      null,                         // tipoAsegurador
      null,                         // estadoSuspension
      true,                             // coberturaDomiciliaria
      null,                     // fechaLimiteCobertura
      {                                 // tipoAfiliacion
        id: '3',
        nombre: 'PÓLIZA',
        nombreAseguradora: 'SURA SEGUROS',
        idPlan: '3'
      },
      [                                 // convenios
        {
          planContrato: '074',
          codigoRamo: '091',
          tipoRamo: 'C',
          tipoPlanSalud: 'POLIZA',
          descripcionPlanContrato: 'Póliza Clásica',
          numeroPlan: '2|CLÁSICO',
          codigoProducto: '15',
          anexoUrgencias: false,
          anexoConsultaExterna: false,
          anexoAtencionDomiciliaria: true,
          fechaInicioVigenciaAsegurado: 1743397200000 as any, // ✅ Cast a any
          fechaFinVigenciaAsegurado: 1774933200000 as any,
          numeroContrato: 'CNT-002'
        }
      ],
      null,                           // nivelIngreso
      'IPS SURA SEDE NORTE',            // ipsBasicaAsignada
      null,                      // lugarAtencion
      'AÑOS',                           // unidadEdad
      null,                               // bebeCanguro
      '',                               // codigoARL
      null,                             // medidaDepeso
      null,                             // peso
      null,                               // codigoSiniestro
      'PLAN_COMPLEMENTARIO_A',          // planComplementario
      true,                             // esEditable
      null,                          // priorizacion
      null,                     // fechaConsultaMedica
      null,                     // fechaInicioSintomas
      null,                     // fechaTomaMuestra
      null,                     // tipoCasoCovid
      null,                // integracion
      null, // observacion
      null,                             // pacienteSinFechaNacimiento
      null,                        // encounterId
      null,                             // embarazada
      null,                             // oxigenoDependiente
      null,            // medicoCreadorTipo
      null,                       // medicoCreadorNumero
      null,                              // codigoSexo
      null,                       // descSexo
      null,                              // codigoPlan
      null,                         // descPlan
      null,                         // descMunicipio
      null,                          // codigoDaneMunicipio
      null,                   // descDepartamento
      null,                             // codigoDaneDpto
      'PISO_2',                         // pisoCovid
      null,                                // subNivel
      null,                     // vacunacion
      'María Elena González López',     // nombrePersonaAutoriza
      true,                             // tienePoliza
      false,                            // tienePac
      false,                            // tienePOS
      false                             // tieneArl
    ),


    // ✅ PACIENTE CON DOCUMENTO 3
    new PacienteCobertura(
      null,                              // idRemisionPK
      'María Elena',                     // nombre
      'González López',                  // apellido
      new TipoIdentificacion(            // tipoIdentificacion
        '1',
        'CC',
        'Cédula de Ciudadanía',
        '13',
        'C'
      ),
      '3',                               // numeroIdentificacion
      402469200000 as any,               // fechaNacimiento
      '40',                              // edad
      'Masculino',                       // sexo
      'Casada',                          // estadoCivil
      {                                  // tipoPlanParticular
        id: '2',
        idTipoPlanParticular: '2',
        descripcion: 'Plan Premium',
        nit: '800123457'
      },
      null,             // ocupacion
      null,        // email
      null,                         // tipoAsegurador
      null,                         // estadoSuspension
      true,                             // coberturaDomiciliaria
      null,                     // fechaLimiteCobertura
      {                                 // tipoAfiliacion
        id: '3',
        nombre: 'PÓLIZA',
        nombreAseguradora: 'SURA SEGUROS',
        idPlan: '3'
      },
      [                                 // convenios
        {
          planContrato: '074',
          codigoRamo: '091',
          tipoRamo: 'C',
          tipoPlanSalud: 'POLIZA',
          descripcionPlanContrato: 'Póliza Clásica',
          numeroPlan: '2|CLÁSICO',
          codigoProducto: '15',
          anexoUrgencias: false,
          anexoConsultaExterna: false,
          anexoAtencionDomiciliaria: true,
          fechaInicioVigenciaAsegurado: 1743397200000 as any, // ✅ Cast a any
          fechaFinVigenciaAsegurado: 1774933200000 as any,
          numeroContrato: 'CNT-002'
        }
      ],
      null,                           // nivelIngreso
      'IPS SURA SEDE NORTE',            // ipsBasicaAsignada
      null,                      // lugarAtencion
      'AÑOS',                           // unidadEdad
      null,                               // bebeCanguro
      '',                               // codigoARL
      null,                             // medidaDepeso
      null,                             // peso
      null,                               // codigoSiniestro
      'PLAN_COMPLEMENTARIO_A',          // planComplementario
      true,                             // esEditable
      null,                          // priorizacion
      null,                     // fechaConsultaMedica
      null,                     // fechaInicioSintomas
      null,                     // fechaTomaMuestra
      null,                     // tipoCasoCovid
      null,                // integracion
      null, // observacion
      null,                             // pacienteSinFechaNacimiento
      null,                        // encounterId
      null,                             // embarazada
      null,                             // oxigenoDependiente
      null,            // medicoCreadorTipo
      null,                       // medicoCreadorNumero
      null,                              // codigoSexo
      null,                       // descSexo
      null,                              // codigoPlan
      null,                         // descPlan
      null,                         // descMunicipio
      null,                          // codigoDaneMunicipio
      null,                   // descDepartamento
      null,                             // codigoDaneDpto
      'PISO_2',                         // pisoCovid
      null,                                // subNivel
      null,                     // vacunacion
      'María Elena González López',     // nombrePersonaAutoriza
      true,                             // tienePoliza
      false,                            // tienePac
      true,                            // tienePOS
      false                             // tieneArl
    ),


    // ✅ PACIENTE CON DOCUMENTO 4
    new PacienteCobertura(
      null,                    // idRemisionPK
      'María Elena',                     // nombre
      'González López',                  // apellido
      new TipoIdentificacion(            // tipoIdentificacion
        '1',
        'CC',
        'Cédula de Ciudadanía',
        '13',
        'C'
      ),
      '4',                               // numeroIdentificacion
      402469200000 as any,                      // fechaNacimiento
      '40',                              // edad
      'Masculino',                               // sexo
      'Casada',                          // estadoCivil
      {                                  // tipoPlanParticular
        id: '2',
        idTipoPlanParticular: '2',
        descripcion: 'Plan Premium',
        nit: '800123457'
      },
      null,             // ocupacion
      null,        // email
      null,                         // tipoAsegurador
      null,                         // estadoSuspension
      true,                             // coberturaDomiciliaria
      null,                     // fechaLimiteCobertura
      {                                 // tipoAfiliacion
        id: '3',
        nombre: 'PÓLIZA',
        nombreAseguradora: 'SURA SEGUROS',
        idPlan: '3'
      },
      [                                 // convenios
        {
          planContrato: '074',
          codigoRamo: '091',
          tipoRamo: 'C',
          tipoPlanSalud: 'POLIZA',
          descripcionPlanContrato: 'Póliza Clásica',
          numeroPlan: '2|CLÁSICO',
          codigoProducto: '15',
          anexoUrgencias: false,
          anexoConsultaExterna: false,
          anexoAtencionDomiciliaria: true,
          fechaInicioVigenciaAsegurado: 1743397200000 as any, // ✅ Cast a any
          fechaFinVigenciaAsegurado: 1774933200000 as any,
          numeroContrato: 'CNT-002'
        },
        {
          planContrato: 'STC',
          codigoRamo: '081',
          tipoRamo: 'C',
          tipoPlanSalud: 'POLIZA',
          descripcionPlanContrato: 'Salud para Dos',
          numeroPlan: '3|CLÁSICO',
          codigoProducto: '16',
          anexoUrgencias: false,
          anexoConsultaExterna: false,
          anexoAtencionDomiciliaria: true,
          fechaInicioVigenciaAsegurado: 1743397200000 as any, // ✅ Cast a any
          fechaFinVigenciaAsegurado: 1774933200000 as any,
          numeroContrato: 'CNT-002'
        },
        {
          planContrato: 'PVC',
          codigoRamo: '091',
          tipoRamo: 'C',
          tipoPlanSalud: 'PAC',
          descripcionPlanContrato: 'PAC PLAN COMPLEMENTARIO',
          numeroPlan: '5|PREMIUM',
          codigoProducto: '06',
          anexoUrgencias: false,
          anexoConsultaExterna: false,
          anexoAtencionDomiciliaria: true,
          fechaInicioVigenciaAsegurado: 1743397200000 as any, // ✅ Cast a any
          fechaFinVigenciaAsegurado: 1774933200000 as any,
          numeroContrato: 'CNT-002'
        }
      ],
      null,                           // nivelIngreso
      'IPS SURA SEDE NORTE',            // ipsBasicaAsignada
      null,                      // lugarAtencion
      'AÑOS',                           // unidadEdad
      null,                               // bebeCanguro
      '',                               // codigoARL
      null,                             // medidaDepeso
      null,                             // peso
      null,                               // codigoSiniestro
      'PLAN_COMPLEMENTARIO_A',          // planComplementario
      true,                             // esEditable
      null,                          // priorizacion
      null,                     // fechaConsultaMedica
      null,                     // fechaInicioSintomas
      null,                     // fechaTomaMuestra
      null,                     // tipoCasoCovid
      null,                // integracion
      null, // observacion
      null,                             // pacienteSinFechaNacimiento
      null,                        // encounterId
      null,                             // embarazada
      null,                             // oxigenoDependiente
      null,            // medicoCreadorTipo
      null,                       // medicoCreadorNumero
      null,                              // codigoSexo
      null,                       // descSexo
      null,                              // codigoPlan
      null,                         // descPlan
      null,                         // descMunicipio
      null,                          // codigoDaneMunicipio
      null,                   // descDepartamento
      null,                             // codigoDaneDpto
      'PISO_2',                         // pisoCovid
      null,                                // subNivel
      null,                     // vacunacion
      'María Elena González López',     // nombrePersonaAutoriza
      false,                             // tienePoliza
      true,                            // tienePac
      true,                            // tienePOS
      true                             // tieneArl
    ),

    // ✅ PACIENTE CON DOCUMENTO 5
    new PacienteCobertura(
      null,                    // idRemisionPK
      'María Elena',                     // nombre
      'González López',                  // apellido
      new TipoIdentificacion(            // tipoIdentificacion
        '1',
        'CC',
        'Cédula de Ciudadanía',
        '13',
        'C'
      ),
      '5',                               // numeroIdentificacion
      402469200000 as any,                      // fechaNacimiento
      '40',                              // edad
      'Masculino',                               // sexo
      'Casada',                          // estadoCivil
      {                                  // tipoPlanParticular
        id: '2',
        idTipoPlanParticular: '2',
        descripcion: 'Plan Premium',
        nit: '800123457'
      },
      null,             // ocupacion
      null,        // email
      null,                         // tipoAsegurador
      null,                         // estadoSuspension
      true,                             // coberturaDomiciliaria
      null,                     // fechaLimiteCobertura
      {                                 // tipoAfiliacion
        id: '3',
        nombre: 'PÓLIZA',
        nombreAseguradora: 'SURA SEGUROS',
        idPlan: '3'
      },
      [                                 // convenios
        {
          planContrato: '074',
          codigoRamo: '091',
          tipoRamo: 'C',
          tipoPlanSalud: 'POLIZA',
          descripcionPlanContrato: 'Póliza Clásica',
          numeroPlan: '2|CLÁSICO',
          codigoProducto: '15',
          anexoUrgencias: false,
          anexoConsultaExterna: false,
          anexoAtencionDomiciliaria: true,
          fechaInicioVigenciaAsegurado: 1743397200000 as any, // ✅ Cast a any
          fechaFinVigenciaAsegurado: 1774933200000 as any,
          numeroContrato: 'CNT-002'
        },
        {
          planContrato: 'STC',
          codigoRamo: '081',
          tipoRamo: 'C',
          tipoPlanSalud: 'POLIZA',
          descripcionPlanContrato: 'Salud para Dos',
          numeroPlan: '3|CLÁSICO',
          codigoProducto: '16',
          anexoUrgencias: false,
          anexoConsultaExterna: false,
          anexoAtencionDomiciliaria: true,
          fechaInicioVigenciaAsegurado: 1743397200000 as any, // ✅ Cast a any
          fechaFinVigenciaAsegurado: 1774933200000 as any,
          numeroContrato: 'CNT-002'
        },
        {
          planContrato: 'PVC',
          codigoRamo: '091',
          tipoRamo: 'C',
          tipoPlanSalud: 'PAC',
          descripcionPlanContrato: 'PAC PLAN COMPLEMENTARIO',
          numeroPlan: '5|PREMIUM',
          codigoProducto: '06',
          anexoUrgencias: false,
          anexoConsultaExterna: false,
          anexoAtencionDomiciliaria: true,
          fechaInicioVigenciaAsegurado: 1743397200000 as any, // ✅ Cast a any
          fechaFinVigenciaAsegurado: 1774933200000 as any,
          numeroContrato: 'CNT-002'
        }
      ],
      null,                           // nivelIngreso
      'IPS SURA SEDE NORTE',            // ipsBasicaAsignada
      null,                      // lugarAtencion
      'AÑOS',                           // unidadEdad
      null,                               // bebeCanguro
      '',                               // codigoARL
      null,                             // medidaDepeso
      null,                             // peso
      null,                               // codigoSiniestro
      'PLAN_COMPLEMENTARIO_A',          // planComplementario
      true,                             // esEditable
      null,                          // priorizacion
      null,                     // fechaConsultaMedica
      null,                     // fechaInicioSintomas
      null,                     // fechaTomaMuestra
      null,                     // tipoCasoCovid
      null,                // integracion
      null, // observacion
      null,                             // pacienteSinFechaNacimiento
      null,                        // encounterId
      null,                             // embarazada
      null,                             // oxigenoDependiente
      null,            // medicoCreadorTipo
      null,                       // medicoCreadorNumero
      null,                              // codigoSexo
      null,                       // descSexo
      null,                              // codigoPlan
      null,                         // descPlan
      null,                         // descMunicipio
      null,                          // codigoDaneMunicipio
      null,                   // descDepartamento
      null,                             // codigoDaneDpto
      'PISO_2',                         // pisoCovid
      null,                                // subNivel
      null,                     // vacunacion
      'María Elena González López',     // nombrePersonaAutoriza
      true,                             // tienePoliza
      true,                            // tienePac
      true,                            // tienePOS
      false                             // tieneArl
    )

  ];

  /**
   * Busca un paciente simulado por número de documento
   * @param documento - Número de documento a buscar
   * @returns PacienteCobertura o null si no se encuentra
   */
  public static buscarPacientePorDocumento(documento: string): PacienteCobertura | null {
    return this.PACIENTES_SIMULADOS.find(paciente => 
      paciente.numeroIdentificacion === documento
    ) || null;
  }

  public static readonly PACIENTES_SIMULADOS_NH: PacienteCoberturaNh[] = [
    
 // ✅ PACIENTE CON DOCUMENTO 1
  {
    tipoIdentificacion: new TipoIdentificacion(
      '1',
      'CC',
      'Cédula de Ciudadanía',
      '13',
      'C'
    ),
    numeroIdentificacion: '1',
    nombre: 'María Elena',
    apellido: 'González López',
    fechaNacimiento: new Date(402469200000), // ✅ Como Date object
    edad: '40',
    sexo: 'Femenino', // ✅ Corregido (era 'Masculino')
    ocupacion: 'Empleada',
    email: 'maria.gonzalez@email.com',
    tipoAfiliacion: {
      id: '3',
      nombre: 'PÓLIZA',
      nombreAseguradora: 'SURA SEGUROS',
      idPlan: '3'
    },
    codigoARL: '',
    celular: '3001234567',
    telefono: '6013456789',
    convenios: [
      {
        planContrato: '074',
        codigoRamo: '091',
        tipoRamo: 'C',
        tipoPlanSalud: 'POLIZA',
        descripcionPlanContrato: 'Póliza Clásica',
        numeroPlan: '2|CLÁSICO',
        codigoProducto: '15',
        anexoUrgencias: false,
        anexoConsultaExterna: false,
        anexoAtencionDomiciliaria: true,
        fechaInicioVigenciaAsegurado: 1735689600000 as any, // 2025-01-01
        fechaFinVigenciaAsegurado: 1767225599000 as any,    // 2025-12-31
        numeroContrato: 'CNT-001'
      }
    ],
    tienePoliza: true,
    tienePac: false,
    tienePOS: false,
    tieneArl: true
  } as PacienteCoberturaNh,


  // ✅ PACIENTE CON DOCUMENTO 2 - AJUSTADO A PacienteCoberturaNh
    {
    tipoIdentificacion: new TipoIdentificacion(
      '1',
      'CC',
      'Cédula de Ciudadanía',
      '13',
      'C'
    ),
    numeroIdentificacion: '2',
    nombre: 'Carlos Alberto',
    apellido: 'Rodríguez Silva',
    fechaNacimiento: new Date(315529200000), // 1980-01-01
    edad: '45',
    sexo: 'Masculino',
    ocupacion: 'Ingeniero',
    email: 'carlos.rodriguez@email.com',
    tipoAfiliacion: {
      id: '1',
      nombre: 'POS',
      nombreAseguradora: 'SURA EPS',
      idPlan: '1'
    },
    codigoARL: null,
    celular: '3009876543',
    telefono: '6017654321',
    convenios: [
        {
          planContrato: '074',
          codigoRamo: '091',
          tipoRamo: 'C',
          tipoPlanSalud: 'POLIZA',
          descripcionPlanContrato: 'Póliza Clásica',
          numeroPlan: '2|CLÁSICO',
          codigoProducto: '15',
          anexoUrgencias: false,
          anexoConsultaExterna: false,
          anexoAtencionDomiciliaria: true,
          fechaInicioVigenciaAsegurado: 1735689600000 as any, // 2025-01-01
          fechaFinVigenciaAsegurado: 1767225599000 as any,    // 2025-12-31
          numeroContrato: 'CNT-001'
        },
        {
          planContrato: '056',
          codigoRamo: '080',
          tipoRamo: 'C',
          tipoPlanSalud: 'POLIZA',
          descripcionPlanContrato: 'Póliza Clásica Familiar',
          numeroPlan: '3|CLÁSICO',
          codigoProducto: '16',
          anexoUrgencias: false,
          anexoConsultaExterna: false,
          anexoAtencionDomiciliaria: true,
          fechaInicioVigenciaAsegurado: 1735689600000 as any, // 2025-01-01
          fechaFinVigenciaAsegurado: 1767225599000 as any,    // 2025-12-31
          numeroContrato: 'CNT-001'
        }
    ],
    tienePoliza: true,
    tienePac: false,
    tienePOS: false,
    tieneArl: false
  } as PacienteCoberturaNh,

  // ✅ PACIENTE CON DOCUMENTO 3 - AJUSTADO A PacienteCoberturaNh
    {
    tipoIdentificacion: new TipoIdentificacion(
      '1',
      'CC',
      'Cédula de Ciudadanía',
      '13',
      'C'
    ),
    numeroIdentificacion: '3',
    nombre: 'Carlos Alberto',
    apellido: 'Rodríguez Silva',
    fechaNacimiento: new Date(315529200000), // 1980-01-01
    edad: '45',
    sexo: 'Masculino',
    ocupacion: 'Ingeniero',
    email: 'carlos.rodriguez@email.com',
    tipoAfiliacion: {
      id: '1',
      nombre: 'POS',
      nombreAseguradora: 'SURA EPS',
      idPlan: '1'
    },
    codigoARL: null,
    celular: '3009876543',
    telefono: '6017654321',
    convenios: [
        {
          planContrato: '074',
          codigoRamo: '091',
          tipoRamo: 'C',
          tipoPlanSalud: 'POLIZA',
          descripcionPlanContrato: 'Póliza Clásica',
          numeroPlan: '2|CLÁSICO',
          codigoProducto: '15',
          anexoUrgencias: false,
          anexoConsultaExterna: false,
          anexoAtencionDomiciliaria: true,
          fechaInicioVigenciaAsegurado: 1735689600000 as any, // 2025-01-01
          fechaFinVigenciaAsegurado: 1767225599000 as any,    // 2025-12-31
          numeroContrato: 'CNT-001'
        },
        {
          planContrato: '056',
          codigoRamo: '080',
          tipoRamo: 'C',
          tipoPlanSalud: 'POLIZA',
          descripcionPlanContrato: 'Póliza Clásica Familiar',
          numeroPlan: '3|CLÁSICO',
          codigoProducto: '16',
          anexoUrgencias: false,
          anexoConsultaExterna: false,
          anexoAtencionDomiciliaria: true,
          fechaInicioVigenciaAsegurado: 1735689600000 as any, // 2025-01-01
          fechaFinVigenciaAsegurado: 1767225599000 as any,    // 2025-12-31
          numeroContrato: 'CNT-001'
        }
    ],
    tienePoliza: true,
    tienePac: false,
    tienePOS: true,
    tieneArl: false
  } as PacienteCoberturaNh,

  // ✅ PACIENTE CON DOCUMENTO 4 - AJUSTADO A PacienteCoberturaNh
    {
    tipoIdentificacion: new TipoIdentificacion(
      '1',
      'CC',
      'Cédula de Ciudadanía',
      '13',
      'C'
    ),
    numeroIdentificacion: '4',
    nombre: 'Carlos Alberto',
    apellido: 'Rodríguez Silva',
    fechaNacimiento: new Date(315529200000), // 1980-01-01
    edad: '45',
    sexo: 'Masculino',
    ocupacion: 'Ingeniero',
    email: 'carlos.rodriguez@email.com',
    tipoAfiliacion: {
      id: '1',
      nombre: 'POS',
      nombreAseguradora: 'SURA EPS',
      idPlan: '1'
    },
    codigoARL: null,
    celular: '3009876543',
    telefono: '6017654321',
    convenios: [
        {
          planContrato: 'PVC',
          codigoRamo: '091',
          tipoRamo: 'C',
          tipoPlanSalud: 'PAC',
          descripcionPlanContrato: 'PAC PLAN COMPLEMENTARIO',
          numeroPlan: '5|PREMIUM',
          codigoProducto: '06',
          anexoUrgencias: false,
          anexoConsultaExterna: false,
          anexoAtencionDomiciliaria: true,
          fechaInicioVigenciaAsegurado: 1743397200000 as any, // ✅ Cast a any
          fechaFinVigenciaAsegurado: 1774933200000 as any,
          numeroContrato: 'CNT-002'
        }

    ],
    tienePoliza: false,
    tienePac: true,
    tienePOS: true,
    tieneArl: true
  } as PacienteCoberturaNh,

  // ✅ PACIENTE CON DOCUMENTO 5 - AJUSTADO A PacienteCoberturaNh
    {
    tipoIdentificacion: new TipoIdentificacion(
      '1',
      'CC',
      'Cédula de Ciudadanía',
      '13',
      'C'
    ),
    numeroIdentificacion: '5',
    nombre: 'Carlos Alberto',
    apellido: 'Rodríguez Silva',
    fechaNacimiento: new Date(315529200000), // 1980-01-01
    edad: '45',
    sexo: 'Masculino',
    ocupacion: 'Ingeniero',
    email: 'carlos.rodriguez@email.com',
    tipoAfiliacion: {
      id: '1',
      nombre: 'POS',
      nombreAseguradora: 'SURA EPS',
      idPlan: '1'
    },
    codigoARL: null,
    celular: '3009876543',
    telefono: '6017654321',
    convenios: [
        {
          planContrato: '074',
          codigoRamo: '091',
          tipoRamo: 'C',
          tipoPlanSalud: 'POLIZA',
          descripcionPlanContrato: 'Póliza Clásica',
          numeroPlan: '2|CLÁSICO',
          codigoProducto: '15',
          anexoUrgencias: false,
          anexoConsultaExterna: false,
          anexoAtencionDomiciliaria: true,
          fechaInicioVigenciaAsegurado: 1735689600000 as any, // 2025-01-01
          fechaFinVigenciaAsegurado: 1767225599000 as any,    // 2025-12-31
          numeroContrato: 'CNT-001'
        },
        {
          planContrato: 'PVC',
          codigoRamo: '091',
          tipoRamo: 'C',
          tipoPlanSalud: 'PAC',
          descripcionPlanContrato: 'PAC PLAN COMPLEMENTARIO',
          numeroPlan: '5|PREMIUM',
          codigoProducto: '06',
          anexoUrgencias: false,
          anexoConsultaExterna: false,
          anexoAtencionDomiciliaria: true,
          fechaInicioVigenciaAsegurado: 1743397200000 as any, // ✅ Cast a any
          fechaFinVigenciaAsegurado: 1774933200000 as any,
          numeroContrato: 'CNT-002'
        }

    ],
    tienePoliza: true,
    tienePac: true,
    tienePOS: true,
    tieneArl: false
  } as PacienteCoberturaNh

  ];


    public static buscarPacientePorDocumentoNH(documento: string): PacienteCoberturaNh | null {
    return this.PACIENTES_SIMULADOS_NH.find(paciente => 
      paciente.numeroIdentificacion === documento
    ) || null;
  }
}
